import $ from "jquery";

$(document).ready(function () {
  // const request_url_site = window.location.host
  // let params = ""


  // let widget_url = url + "/chatbot?requesturl=" + request_url_site + params
  // if (localStorage.getItem('isonichidebydefault') == null) {
  //   localStorage.setItem('isonichidebydefault', 'true');
  // } else if (localStorage.getItem('isonichidebydefault') == 'true') {
  //   widget_url = widget_url + "&hide_by_default=true"
  // } else {
  //   widget_url = widget_url + "&hide_by_default=false"
  //   localStorage.setItem('isonichidebydefault', 'false');

  // }
  // if (localStorage.getItem('isonicftu') == 'yes') {
  //   localStorage.setItem('isonicftu', 'yes');
  //   widget_url = widget_url + "&ftu=true"
  // } else {
  //   localStorage.setItem('isonicftu', 'no');
  // }

  let PARENT_WIDTH;

  function openWidget(el) {
    $("#widgetButton").addClass("no-display");
    $(".startconvwidget").removeClass("no-display");

    if ($(el).attr("version") == 'custom_v1') {
      $(".startconvwidget").attr("open", "")
      const height = PARENT_WIDTH < 800 ? "100%" : PARENT_WIDTH < 1120 ? "784px" : "360px";
      const width = PARENT_WIDTH < 800 ? "100%" : PARENT_WIDTH < 1120 ? "390px" : "auto";
      resizeLetschat(height, width);

      if (PARENT_WIDTH >= 1120) changeFlex("100"); else window.parent.postMessage(["setShadowEffect", "0 4px 8px 0 rgba(0, 0, 0, 0.2), 0 6px 20px 0 rgba(0, 0, 0, 0.19)"], "*");

    } else {
      const height = PARENT_WIDTH < 800 ? "100%" : "784px";
      const width = PARENT_WIDTH < 800 ? "100%" : "390px";
      resizeLetschat(height, width);
      window.parent.postMessage(["setShadowEffect", "0 4px 8px 0 rgba(0, 0, 0, 0.2), 0 6px 20px 0 rgba(0, 0, 0, 0.19)"], "*");
      if (PARENT_WIDTH < 800) window.parent.postMessage(["movePin", { bottom: "0", right: "0" }], "*");

    }
    window.parent.postMessage(["setBorderRadius", "20px"], "*");
  }

  window.addEventListener('message', (event) => {
    if (event.data?.type === 'parentWidth') {
      const parentWidth = event.data.width;
      PARENT_WIDTH = parentWidth;
      const widgetBtn = document.getElementById("widgetButton");

      document.documentElement.style.setProperty('--parent-width', `${parentWidth}px`);
      if ($("#widgetButton").attr("version") === 'custom_v1') {
        if (parentWidth < 1120) {
          widgetBtn.style.top = "auto";
          widgetBtn.style.bottom = "0";
          widgetBtn.style.right = "0";
          document.body.classList.add('mobile');
          document.body.classList.remove('desktop');
          window.parent.postMessage(["movePin", { bottom: "24px", right: "24px" }], "*");
        } else {
          widgetBtn.style.removeProperty("top");
          widgetBtn.style.removeProperty("bottom");
          widgetBtn.style.removeProperty("right");
          document.body.classList.remove('mobile');
          document.body.classList.add('desktop');
        }

        if ($(".startconvwidget").attr("open") !== undefined) {
          const height = parentWidth < 800 ? "100%" : parentWidth < 1120 ? "784px" : "360px";
          const width = parentWidth < 800 ? "100%" : parentWidth < 1120 ? "390px" : "auto";
          resizeLetschat(height, width);
          if (parentWidth >= 1120) {
            changeFlex("100");
            window.parent.postMessage(["setShadowEffect", "none"], "*");
            window.parent.postMessage(["setBorderRadius", "0"], "*");
          } else {
            window.parent.postMessage(["setShadowEffect", "0 4px 8px 0 rgba(0, 0, 0, 0.2), 0 6px 20px 0 rgba(0, 0, 0, 0.19)"], "*");
            window.parent.postMessage(["setBorderRadius", "20px"], "*");
            const pin = parentWidth < 800 ? "0" : "24px"
            window.parent.postMessage(["movePin", { bottom: pin, right: pin }], "*")
          }
        }
      } else {
        if (!document.querySelector(".startconvwidget").classList.contains("no-display")) {
          const height = parentWidth < 800 ? "100%" : "784px"
          const width = parentWidth < 800 ? "100%" : "390px"
          resizeLetschat(height, width);
          window.parent.postMessage(["setShadowEffect", "0 4px 8px 0 rgba(0, 0, 0, 0.2), 0 6px 20px 0 rgba(0, 0, 0, 0.19)"], "*");
        } else {
          const height = 80
          const width = 80
          resizeLetschat(height, width);
          window.parent.postMessage(["setShadowEffect", "none"], "*");
        }
      }
    }

    if (event.data?.type === 'hideByDefault') {
      if (event.data.hideByDefault === 'false') openWidget(document.getElementById("widgetButton"));
    }
  });

  $(document).on("click", "#widgetButton", function () {
    openWidget(this);
  });

  $(document).on("click", ".closeletschatwidget", function () {
    $("#widgetButton").removeClass("no-display")
    $(".startconvwidget").addClass("no-display")

    window.parent.postMessage(["setBorderRadius", "80px"], "*");
    resizeLetschat(80, 80)
    window.parent.postMessage(["setShadowEffect", "none"], "*");
    window.parent.postMessage(["closeWidget", "none"], "*");
    window.location.reload();
  });

  $(document).on("click", ".minimizewidget", function () {
    if ($("#widgetButton").attr("version") != 'custom_v1') {
      $(".startconvwidget").addClass("no-display")
      $("#widgetButton").removeClass("no-display")
    } else {
      $(".startconvwidget").removeAttr("open");

      if (PARENT_WIDTH < 1120) {
        $("#widgetButton").removeClass("no-display")
        $(".startconvwidget").addClass("no-display");
      } else {
        $(".startconvwidget").attr("closing", "");
        changeFlex("1");
        $(".startconvwidget").one("animationend", () => {
          $("#widgetButton").removeClass("no-display")
          $(".startconvwidget").removeAttr("closing");
          $(".startconvwidget").addClass("no-display");
        })
      }
    }
    window.parent.postMessage(["setBorderRadius", "20px"], "*");
    if ($("#widgetButton").attr("version") == 'custom_v1') {
      const height = PARENT_WIDTH < 1120 ? "44px" : "360px";
      const width = "169px";
      resizeLetschat(height, width);
      window.parent.postMessage(["movePin", { bottom: "24px", right: "24px" }], "*")
    } else {
      resizeLetschat(80, 80);
    }
    window.parent.postMessage(["setShadowEffect", "none"], "*");
    window.parent.postMessage(["closeWidget", "none"], "*");

  });

  $(document).on("click", ".widget-items", function () {
    $('.startconv').append('<div id="widgetloader"><p>loading...</p></div>');
    $.ajax({
      url: "/widget/request_tab",
      type: "get",
      dataType: "script",
      data: { widget_id: $("#topmenuwidget").attr('data-widget'), tab: $(this).data('action'), conversation_id: $('#topmenuwidget').attr("data-conversation") },
      success: function (data) {
        checkStarterQuestions();
      },
      error: function () {
        $('#widgetloader').remove();
      }
    })
  });

  const checkbox = document.getElementById('isonichidebydefault');

  checkbox.addEventListener('change', () => {
    const message = {
      type: 'isonichidebydefault',
      key: 'isonichidebydefault',
      value: checkbox.checked
    };

    // Send to parent window
    window.parent.postMessage([message.type, message.value], '*'); // You can replace '*' with a specific origin for security
  });

  $(document).on("focusin", ".messageboxbottom", function () {
    const isMobile = /Mobi|Android|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent);

    if (!isMobile) return;
    $(document.body).toggleClass("scroll-lock", true);
  })

  $(document).on("focusout", ".messageboxbottom", function () {
    const isMobile = /Mobi|Android|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent);

    if (!isMobile) return;
    $(document.body).toggleClass("scroll-lock", false);
  })

  $(document).on("click", "#messageme", function () {
    $('.startconv').append('<div id="widgetloader"><p>loading...</p></div>');
    $.ajax({
      url: "/widget/request_tab",
      type: "get",
      dataType: "script",
      data: { widget_id: $("#topmenuwidget").attr('data-widget'), tab: "message", conversation_id: $('#topmenuwidget').attr("data-conversation") },
      success: function (data) {
      },
      error: function () {
        $('#widgetloader').remove();
      }

    })
  });


  $(document).on("keyup", "#usermessageinput", function (e) {
    e.preventDefault();
    var keycode = (e.keyCode ? e.keyCode : e.which);
    if (keycode === 13 || e.key === 'Enter') {
      if ($('#usermessageinput').val().trim() === '') return;
      sendChatMessage("#sendchatreq");
    }
  });

  $(document).on("click", "#sendchatreq", function () {
    if ($('#usermessageinput').val().trim() === '') return;
    sendChatMessage(this);
  });

  $(document).on("click", ".chatbotsquestion", function () {
    const value = $(this).html().trim();
    $('#conversationprogress').append(`<div class="chat-bubble-container user fadein">
	      <div class="chat-bubble">
	          <p>${value}</p>
	      </div>
	  	</div>`)
    $('#conversationprogress').append(`<div class="chat-bubble-container system fadein">
			<div class="chat-bubble loading">
				<lottie-player src="https://lottie.host/a97c305c-1f5a-4365-97cf-b957ad73d2ba/kzqHqUET4M.json" background="transparent" speed="1" style="width: 40px; height: 40px;" loop autoplay disableShadowDOM ></lottie-player>
			</div>
		</div>`)
    $('#usermessageinput').val('')

    let timeout;
    timeout = setTimeout(() => {
      for (const el of document.getElementsByClassName('fadein')) {
        el.classList.remove('fadein');
      }
    }, 150)

    const element = $('#conversationprogressparent');
    element.animate({
      scrollTop: element.prop("scrollHeight")
    }, 0);

    let data = { message: value, id: $("#topmenuwidget").attr('data-conversation') }
    $.ajax({
      url: "/api/chatbot/conversation",
      type: "post",
      dataType: "script",
      data: data,
      success: function (data) {
        checkStarterQuestions();
      }

    })
  });

  const checkStarterQuestions = () => {
    const starterQuestionList = document.querySelector(".starter-questions-input");
    const chatThread = document.querySelector(".chat-thread");
    const lastMessage = document.getElementById("wlastmessage");

    const cleanText = text => text.replace(/\s+/g, " ").trim();

    let askedQuestions = [];
    for (let question of chatThread.children) {
      if (question.classList.contains("user")) {
        askedQuestions.push(cleanText(question.textContent));
      }
    }

    for (let question of starterQuestionList.children) {
      if (askedQuestions.includes(question.textContent)) {
        starterQuestionList.removeChild(question);
      }
    }

    const linkCount = lastMessage.getElementsByClassName("link-container").length;
    chatThread.style.setProperty("--animation-delay", (linkCount * 50) + 150);
    chatThread.style.setProperty("--padding-bottom", starterQuestionList.children.length > 0 ? "40px" : "0px")
  }

  // $(document).on("click", "#gobackmain", function(){
  // 	$('.startconv').append('<div id="widgetloader"><p>loading...</p></div>');
  // 	$.ajax({
  // 		url: "/widget/request_tab",
  // 		type: "get",
  // 		dataType: "script",
  // 		data: {widget_id: $("#topmenuwidget").attr('data-widget'), navigation: "yes", conversation_id: $('#topmenuwidget').attr("data-conversation")},
  // 		success: function(data){

  // 		},
  // 		error: function(){
  // 			$('#widgetloader').remove();
  // 		}

  // 	})
  // });

});



// =============== START function =====>>>>
function resizeLetschat(height, width) {
  window.parent.postMessage(["setHeight", height], "*");
  window.parent.postMessage(["setWidth", width], "*");
}

function changeFlex(flex) {
  window.parent.postMessage(["setFlex", flex], "*")
}

function copyText(element) {
  var $temp = $("<textarea>");
  $("body").append($temp);
  $temp.val($(element).html().replace(/<br>/g, "\n").replace(/\t/g, "")).select();
  try {
    document.execCommand("copy");
    $temp.remove();
    $('#widgetquestionreply').html($temp.val())
  }
  catch (err) {
    alert('unable to copy text');
  }
}

function copyTextOnly(element) {
  var $temp = $("<textarea>");
  $("body").append($temp);
  $temp.val($(element).html().replace(/<br>/g, "\n").replace(/\t/g, "")).select();
  try {
    document.execCommand("copy");
    $temp.remove();
    swal('Success', 'Link copied', 'success');
  }
  catch (err) {
    swal('Error', 'unable to copy text', 'error');
  }
}



function sendChatMessage(domId) {
  $('#usermessageinput').trigger('blur');
  const value = $('#usermessageinput').val()
  if (value == null || value == '') return false;
  if ($('.chattingmessage').length > 0) {
    return false
  };
  if ($('#chatplaceholder').length > 0) $('#chatplaceholder').remove()

  $('#conversationprogress').append(`<div class="chat-bubble-container user fadein">
    <div class="chat-bubble">
      <p>${value}</p>
    </div>
  </div>`)
  $('#conversationprogress').append(`<div class="chat-bubble-container system fadein">
		<div class="chat-bubble loading">
			<lottie-player src="https://lottie.host/a97c305c-1f5a-4365-97cf-b957ad73d2ba/kzqHqUET4M.json" background="transparent" speed="1" style="width: 40px; height: 40px;" loop autoplay disableShadowDOM ></lottie-player>
		</div>
	</div>`)
  $('#usermessageinput').val('')

  let timeout;
  timeout = setTimeout(() => {
    for (const el of document.getElementsByClassName('fadein')) {
      el.classList.remove('fadein');
    }
  }, 150)

  const element = $('#conversationprogressparent');
  element.animate({
    scrollTop: element.prop("scrollHeight")
  }, 0);

  let data = { message: value, id: $(domId).attr('data-convoid') }

  if ($('#usermessageinput').attr('data-mongo') === 'yes') {
    data['mongo'] = true
  }

  $.ajax({
    url: "/api/chatbot/conversation",
    type: "post",
    dataType: "script",
    data: data,
    success: function (data) {

    },
    error: function () {
      $('#conversationprogress > .chat-bubble-container.system').remove()
      $('#conversationprogress > .loading').remove()
    }
  })

  return () => {
    if (timeout) clearTimeout(timeout);
  }
}

// =============== END function =====<<<<<<



